import { Tab } from '@mercai/clever'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import type { SaleOrderProps } from '@/types'
import styles from './logistic-form.module.css'
import type {
  LogisticFormProps,
  LogisticFormTabsEnum,
} from './logistic-form.type'

import {
  LogisticFormCosts,
  LogisticFormDocuments,
  LogisticFormTransport,
} from './components'
import documentsList from './components/documents/documents.constants'

export const LogisticForm = ({
  onChange,
  values = {} as SaleOrderProps,
  onRefetch,
  initialTab = 'transport',
}: LogisticFormProps) => {
  const { t } = useTranslation('componentOrderCenterForm')

  const [tab, setTab] = useState(initialTab)

  const tabsContent: Record<string, React.ReactNode> = {
    transport: <LogisticFormTransport onChange={onChange} values={values} />,
    costs: <LogisticFormCosts onChange={onChange} values={values} />,
    internalDocuments: (
      <LogisticFormDocuments
        onChange={onChange}
        values={values}
        onSuccessUpload={onRefetch}
        documentsList={documentsList.internal}
      />
    ),
    externalDocuments: (
      <LogisticFormDocuments
        onChange={onChange}
        values={values}
        onSuccessUpload={onRefetch}
        documentsList={documentsList.external}
      />
    ),
  }

  return (
    <div className={styles.core}>
      <Tab
        items={[
          {
            label: t('logisticTabTransport'),
            value: 'transport',
          },
          {
            label: t('logisticTabCosts'),
            value: 'costs',
          },
          {
            label: t('logisticTabInternalDocuments'),
            value: 'internalDocuments',
          },
          {
            label: t('logisticTabExternalDocuments'),
            value: 'externalDocuments',
          },
        ]}
        onChange={(value) => setTab(value as keyof typeof LogisticFormTabsEnum)}
        value={tab}
      />

      {tabsContent[tab]}
    </div>
  )
}
